import { call, put } from 'redux-saga/effects';

import { publishWorkflowDraft } from 'api/WorkflowsAPI';
import { addNegativeToastWithErrorId, addPositiveToast } from 'modules/toastContainer';
import { getErrorResponse } from 'utils/xhr';
import { WorkflowType } from '../../enums';
import { saveWorkflowWithoutCampaignMetadata } from '../../utils';
import { PublishWorkflowDraftRequestAction, actions } from '../actions';

export default function* publishWorkflowDraftSaga(action: PublishWorkflowDraftRequestAction) {
  const message = `Error publishing journey. Please try again later.`;
  try {
    yield put(actions.updateIsAsyncLoading(true));
    const { workflow } = action.payload;
    const updatedWorkflow = saveWorkflowWithoutCampaignMetadata(workflow);
    const { workflowId } = yield call(publishWorkflowDraft, updatedWorkflow);
    if (!workflowId) {
      yield put(addNegativeToastWithErrorId(message, 'publishWorkflowDraftSaga'));
    } else {
      yield put(actions.updateHasUnsavedChanges(false));
      yield put(actions.fetchWorkflowRequest(workflowId, WorkflowType.PUBLISHED, true));
      yield put(addPositiveToast('Journey published'));
    }
    yield put(actions.updateIsAsyncLoading(false));
  } catch (error) {
    const err = getErrorResponse(error);
    yield put(actions.updateIsAsyncLoading(false));
    yield put(actions.saveWorkflowError(err));
    yield put(addNegativeToastWithErrorId(message, 'publishWorkflowDraftSaga'));
  }
}
